import {Component, Inject, Optional, ViewChild} from '@angular/core';
import {NotificationsService} from "@logbook/shared";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {InvitationService} from "@logbook/shared";
import {MixpanelService} from "../../../../../../../app/core/tracking/mixpanel.service";
import {MixpanelEvent} from "../../../../../../../app/core/tracking/mixpanel-event.enum";
import {first} from "rxjs/operators";

@Component({
    selector: 'dln-invite-colleague-modal',
    templateUrl: './invite-colleague-modal.html',
    styleUrls: [
        'invite-colleague-modal.scss'
    ]
})
export class InviteColeagueModalComponent {

    @ViewChild('invitationForm') private invitationForm;
    isLoading = false;
    colleagueEmail: string;
    private skipApiCall = true;

    constructor(@Optional() @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<InviteColeagueModalComponent>,
                private invitationService: InvitationService, private mixpanelService: MixpanelService,
                private notificationsService: NotificationsService) {
        (this.data) ? this.skipApiCall = this.data.skipApiCall : this.skipApiCall = false;
    }

    cancel() {
        this.dialogRef.close(null);
    }

    sendInvitation() {
        if (this.invitationForm.valid && this.colleagueEmail.indexOf('@') > -1) {
            if (!this.skipApiCall) {
                this.invitationService.sendInvitation(this.colleagueEmail).pipe(first()).subscribe(
                    (message) => {
                        this.mixpanelService.track(MixpanelEvent.SEND_INVITATION, {"member mail": this.colleagueEmail});
                        this.notificationsService.success("Invitation sent", message.message);
                        this.dialogRef.close(this.colleagueEmail);
                    }, (error) => {
                        this.notificationsService.error("Invitation cannot be send",  this.colleagueEmail + ' is already member of a team');
                        this.dialogRef.close(null);
                    });
            } else {
                this.dialogRef.close(this.colleagueEmail);
            }
        } else {
            this.notificationsService.error("Invitation cannot be send", "Please verify inserted email")
        }
    }

}
